import { createSelector } from 'reselect';
import type { RootState } from '@/redux/types';

const getCampaignState = createSelector(
  [(state: RootState) => state.campaign],
  (campaignState) => campaignState
);

const getGameIndex = createSelector(
  getCampaignState,
  (campaignState) => campaignState.gameIndex ?? 0
);

export const getCampaign = createSelector(
  (state: RootState) => state,
  (state) => state.campaign
);

export const getCampaignId = createSelector(
  getCampaignState,
  (campaignState) => campaignState.id
);

export const getCampaignGame = createSelector(
  getGameIndex,
  getCampaignState,
  (gameIndex, campaignState) => campaignState.campaignGames?.[gameIndex]
);

export const getCampaignGameIndex = createSelector(
  getGameIndex,
  getCampaignState,
  (gameIndex, campaignState) => campaignState.campaignGames?.[gameIndex].id
);

export const getCampaignCurrentTime = createSelector(
  getCampaignState,
  (campaignState) => campaignState.currentTime
);

export const getCampaignTranslations = createSelector(
  getCampaignState,
  (campaignState) => campaignState.translations
);
